import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import LinearProgress from '@mui/material/LinearProgress';
import * as React from 'react';
import { useTheme } from 'styled-components';
import { Logo } from '../Logo';
import { Brand, SplashWrapper } from './styled';

const Splash: React.FC = () => {
  const { palette } = useTheme();

  return (
    <Fade in>
      <div>
        <Backdrop open style={{ backgroundColor: palette.background.default }}>
          <SplashWrapper>
            <Brand>
              <Logo variant="dark" />
              <Box width="50%">
                <LinearProgress color="primary" />
              </Box>
            </Brand>
          </SplashWrapper>
        </Backdrop>
      </div>
    </Fade>
  );
};

Splash.displayName = 'Splash';

export { Splash };
